import React from "react";
import "./Frame11742.css";
import { Link } from "react-router-dom";

function Frame11742() {
  return (
    <Link to="/kanban-1">
    <div className="frame-117-76">
      <div className="kanban valign-text-middle inter-medium-star-dust-18px">Kanban</div>
    </div>
    </Link>
  );
}

export default Frame11742;
